// @flow

const singleSelectStrategy = ({options}: FacetWithConfig): boolean => (
    options.length > 1
);

export default singleSelectStrategy;
